<template>
  <!-- The heading colour is applied here rather than inside each variant: it
       covers every heading the module renders, including ones in WYSIWYG output
       and nested partials, without any variant knowing about it. -->
  <div class="@container w-full" :class="headingColourClass(pageModule.config)" :style="headingColourStyle(pageModule.config)">
    <component :is="pageModule.variant.component" :config="pageModule.config" :data="data" :module-id="pageModule.id">
      <p>Component "{{ pageModule.variant.component }}" not installed</p>
    </component>
  </div>
</template>

<script>
import headingColourMixin from '@/js/mixins/headingColourMixin.js'

export default {
  components: {},
  mixins: [headingColourMixin],
  props: {
    pageModule: {
      type: Object,
      required: true
    }
  },
  computed: {
    data() {
      // Chrome modules (header/footer) live inside the `chrome` once-prop
      // alongside the header/footer pages themselves; regular page modules
      // live as flat `module_{id}` keys on $page.props. Check the once-prop
      // dict first since it's authoritative for anything that lives there.
      const key = `module_${this.pageModule.id}`
      return this.$page.props.chrome?.moduleData?.[key] ?? this.$page.props[key] ?? null
    }
  }
}
</script>
